import axios from 'axios';

import type { Guid } from '@apple/utils/primitive';

import { type ShipmentReportModel, shipmentReportModelSchema } from '../models/shipment-report';

/** @see AppleRetail.Web.Features.StoreEvents.StoreEventManagementController.GetShipmentReport */
export async function getShipmentReport(
	storeEventId: Guid,
	signal?: AbortSignal,
): Promise<ShipmentReportModel> {
	const response = await axios.get<unknown>(
		`/api/management/store-events/shipment-report/${storeEventId}`,
		{ signal },
	);
	return shipmentReportModelSchema.parse(response.data);
}
